import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IRegistration } from '../utilities/backendTypes';
import registrationService from '../service/RegistrationService';
import { copyTo } from '../utilities/functions';

export interface RegistrationState {
  newUser: IRegistration;
}

export const initialState: RegistrationState = {
  newUser: {} as IRegistration,
} as const;

export const registerUser = createAsyncThunk('registerUser', registrationService.registerUser);

export const registrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state, action) => {
        state.newUser = {
          error: '',
        } as IRegistration;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        console.log('action.payload ', action.payload);
        state.newUser = action.payload;
        state.newUser.error = '';
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.newUser = {
          success: false,
          error: 'error',
        } as IRegistration;
      });
  },
});

export default registrationSlice.reducer;
